import React from 'react';
import { colors } from '@guryou/colors';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// Plain surface card: bordered white panel with soft shadow, optional top accent
// strip, hover/selected treatments. Unlike `Card` (an opinionated MUI Card with
// header/media/width overrides), this is a generic layout surface — first consumer
// is the AI Studio 2 module, themable per call site via @guryou/colors tokens.

const DEFAULT_SHADOW = '0 1px 4px rgba(0, 0, 0, 0.05)';
const DEFAULT_HOVER_SHADOW = '0 3px 12px rgba(230, 97, 106, 0.12)';

// styled-components v4 forwards every prop to the DOM node, so strip the style
// props here (canonical v4 pattern) before rendering the host element.
const SurfaceBase = ({
  background,
  borderColor,
  radius,
  shadow,
  padding,
  accentTop,
  hoverable,
  hoverBorderColor,
  hoverShadow,
  selected,
  selectedBorderColor,
  selectedShadow,
  ...rest
}) => /*#__PURE__*/React.createElement("div", rest);
const toCssSize = value => typeof value === 'number' ? `${value}px` : value;
const SurfaceCard = styled(SurfaceBase)`
  background: ${p => p.background || colors.white};
  border: 1px solid ${p => p.selected ? p.selectedBorderColor || colors.mandy : p.borderColor || colors.lightgrey};
  border-radius: ${p => p.radius === undefined ? 14 : p.radius}px;
  box-shadow: ${p => p.selected ? p.selectedShadow || p.hoverShadow || DEFAULT_HOVER_SHADOW : p.shadow || DEFAULT_SHADOW};
  ${p => p.padding === undefined ? '' : `padding: ${toCssSize(p.padding)};`}
  ${p => p.accentTop ? `border-top: 3px solid ${p.accentTop}; border-top-left-radius: 10px; border-top-right-radius: 10px;` : ''}
  ${p => p.hoverable || p.onClick ? 'transition: border-color 0.15s, box-shadow 0.15s;' : ''}
  ${p => p.onClick ? 'cursor: pointer;' : ''}
  ${p => p.hoverable ? `&:hover {
          border-color: ${p.hoverBorderColor || colors.mandy};
          box-shadow: ${p.hoverShadow || DEFAULT_HOVER_SHADOW};
        }` : ''}
`;
SurfaceBase.propTypes = {
  background: PropTypes.string,
  borderColor: PropTypes.string,
  radius: PropTypes.number,
  shadow: PropTypes.string,
  padding: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  accentTop: PropTypes.string,
  hoverable: PropTypes.bool,
  hoverBorderColor: PropTypes.string,
  hoverShadow: PropTypes.string,
  selected: PropTypes.bool,
  selectedBorderColor: PropTypes.string,
  selectedShadow: PropTypes.string
};
export { SurfaceCard };